import React from 'react';
import styles from './STBIntroduction.module.scss';

interface FeatureItemProps {
  imageSrc: string;
  title: string;
  subtitle?: string;
}

const FeatureItem: React.FC<FeatureItemProps> = ({ imageSrc, title, subtitle }) => (
  <div className={styles["item"]}>
    <div className={styles["image"]}><img src={imageSrc} alt="" /></div>
    <h4>{title}<br /> {subtitle && <small>{subtitle}</small>}</h4>
  </div>
);

export default FeatureItem;